// src/data/questionsData.js

export const questionsData = [
  {
    id: 1,
    question: 'What is the second pillar of Islam?',
    options: [
      'Fasting (Sawm)',
      'Prayer (Salah)',
      'Pilgrimage (Hajj)',
      'Charity (Zakat)',
    ],
    answer: 'Prayer (Salah)',
  },
  {
    id: 2,
    question: "What is the name of Prophet Muhammad's (PBUH) mother?",
    options: ['Halimah', 'Aisha', 'Aminah', 'Khadijah'],
    answer: 'Aminah',
  },
  {
    id: 3,
    question: 'How many Surahs (chapters) are there in the Quran?',
    options: ['110', '114', '120', '116'],
    answer: '114',
  },
  {
    id: 4,
    question: 'In which city is the Kaaba located?',
    options: ['Madinah', 'Jerusalem', 'Makkah', 'Damascus'],
    answer: 'Makkah',
  },
  {
    id: 5,
    question: 'What is the name of the month when Muslims fast?',
    options: ['Shawwal', 'Muharram', 'Rajab', 'Ramadan'],
    answer: 'Ramadan',
  },
];
